var _rect, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsUnreadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 16.6667C25 15.3407 24.4732 14.0689 23.5355 13.1312C22.5979 12.1935 21.3261 11.6667 20 11.6667C18.6739 11.6667 17.4021 12.1935 16.4645 13.1312C15.5268 14.0689 15 15.3407 15 16.6667C15 22.5001 12.5 24.1667 12.5 24.1667H27.5C27.5 24.1667 25 22.5001 25 16.6667Z",
    stroke: "#3F3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4419 27.5C21.2954 27.7526 21.0851 27.9622 20.8321 28.1079C20.5791 28.2537 20.2922 28.3304 20.0003 28.3304C19.7083 28.3304 19.4214 28.2537 19.1684 28.1079C18.9154 27.9622 18.7051 27.7526 18.5586 27.5",
    stroke: "#3F3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 7,
    r: 6,
    fill: "#F95656",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsUnreadIcon);
export default __webpack_public_path__ + "static/media/notificationsUnreadIcon.a1bb87dd11c944d07f404b167632ad84.svg";
export { ForwardRef as ReactComponent };